export const theme2 : object = {
    palette: {
        mode: 'dark', // Switching the dark mode on is a single property value change.
    },
};

